import React, { useEffect, useState, useContext, createContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { UserContext } from '../App';
import MainLayoutWrapper from './MainLayoutWrapper';
import { getLoginToken } from './../helpers/UserHelper';

export const MenskundeContext = createContext(null);

function MenskundeLayoutWrapper({ settings }) {
    const userContext = useContext(UserContext);
    const location = useLocation();

    const [menskundeTopics, setMenskundeTopics] = useState([]);

    useEffect(() => {
        if (getLoginToken() === null || userContext.fetchHeaders === null || menskundeTopics.length > 0) return;

        try {
            fetch(settings.apiBaseUrl + 'menskunde/general', {
                method: 'POST',
                headers: userContext.fetchHeaders,
            })
                .then(result => result.json())
                .then(response => {
                    if (!response.success) return;
                    setMenskundeTopics(response.menskunde.topics);
                });
        } catch (error) {
            console.error(error);
        }
    }, [userContext.fetchHeaders, settings.apiBaseUrl, location.pathname, menskundeTopics.length]);

    const getTopic = function(topicSlug) {
        return menskundeTopics.find(topic => topic.slug === topicSlug) || null;
    };

    return (
        <MenskundeContext.Provider value={{
            topics: menskundeTopics,
            getTopic
        }}>
            <MainLayoutWrapper settings={settings}>
                <Outlet key={location.pathname} />
            </MainLayoutWrapper>
        </MenskundeContext.Provider>
    );
}

export default MenskundeLayoutWrapper;